<template>
  <v-confirmation-dialog @confirm="remove" :text="text">
    <template #activator="{ on }">
      <v-btn v-on="on" icon :loading="loading">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </template>
  </v-confirmation-dialog>
</template>

<script>
import { mapActions } from "vuex";
import VConfirmationDialog from "@/components/confirmations/ConfirmationDialog.vue";

export default {
  components: {
    VConfirmationDialog
  },
  data: () => ({
    loading: false
  }),
  props: {
    /**
     * The rule object that contains the id of the rule to delete.
     */
    rule: {
      type: Object,
      required: true
    }
  },
  computed: {
    text() {
      return `¿Estás seguro que quieres eliminar esta regla? Esto eliminará ${this.rule.featuresCreated} features con valor "${this.rule.value}"`;
    }
  },
  methods: {
    ...mapActions("featureRules", ["removeRule"]),
    async remove() {
      this.loading = true;
      await this.removeRule(this.rule.id);
      this.loading = false;
    }
  }
};
</script>